import { render, staticRenderFns } from "./EditarItem.vue?vue&type=template&id=5bd89947&"
import script from "./EditarItem.vue?vue&type=script&lang=js&"
export * from "./EditarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports